import { emptyFormData } from './requestsConstants';
import { isAdminOrManagerRole, ROLE_USER, normalizeRole } from '../../utils/userRoles';

const FILE_ARRAY_KEYS = ['graphicFiles', 'webDevFiles', 'businessFiles'];

/**
 * Maps API request shape to the detail-dialog form shape (file previews, etc.).
 */
export function transformForEdit(request) {
  if (!request) return emptyFormData;

  const transformed = {
    ...emptyFormData,
    ...request,
    userId: request.userId,
  };

  FILE_ARRAY_KEYS.forEach((fileArrayName) => {
    if (transformed[fileArrayName] && transformed[fileArrayName].length > 0) {
      transformed[fileArrayName] = transformed[fileArrayName].map((file) => ({
        ...file,
        name: file.originalName,
        preview: file.path ? `/${file.path}` : null,
        type: file.mimeType || '',
      }));
    }
  });

  return transformed;
}

/**
 * Whether the current user may edit fields for this request in the detail dialog.
 */
export function canEditRequest(request, currentUser, isEditMode) {
  if (!request || !currentUser) return false;
  if (request.status === 'Closed') return false;
  if (isAdminOrManagerRole(currentUser.role)) return true;
  if (normalizeRole(currentUser.role) === ROLE_USER) {
    if (request.paymentStatus === 'Paid') return false;
    if (request.status === 'Pending payment') {
      return Boolean(isEditMode);
    }
    return true;
  }
  return false;
}
